/**
 * Texts for FAQs page
 */
export const faqPageText = {
    title: 'FAQ - CamAPS FX',
    titleMeta: 'Har du en fråga om CamAPS FX?',
    descriptionMeta: 'Här hittar du svaren på några vanliga frågor om kompatibla enheter, regulatoriskt godkännande, tillgänglighet och klinisk forskning.',
    keywords:
        'camaps faqs, camaps fx faqs, ', 
        // 'type 1 diabetes, autoimmune disease, hyperglycemia, dexcom g6, type 1 diabetes symptoms, blood sugar monitor, diasend, insulin pump, diabetes type 1, blood glucose monitor, blood sugar, cgm, high blood sugar, type 1 diabetes causes, what is type 1 diabetes, diabetes in children, type 1, diabetes treatment, type 1 diabetes treatment, what is hypoglycemia, hypoglycemia treatment, jdrf, blood glucose meters, glucose monitor, type one diabetes, continuous glucose monitoring, type 1 diabetes in children, diabetes pump, t1d, closed loop system, diabetes machine, diabetic gastroparesis, diabetic hypoglycemia, diasend uk, diabetes 1, blood glucose monitor boots,  ',
    localeMeta: 'sv_se',

    haveQuestion: 'Har du en fråga om CamAPS FX?',
    hereAnswers: 'Här hittar du svaren på några vanliga frågor.',
    whatIsCamAPS: 'Vad är CamAPS FX?',
    whatIsCamAPSAnswer: 'CamAPS FX är en sofistikerad och användarvänlig app som hjälper till att hantera glukosvärden hos personer med diabetes typ 1 från ett års ålder, genom en avancerad, adaptiv hybridmetod med closed-loop.',
    isApproved: 'Är CamAPS FX godkänd för användning?',
    isApprovedAnswer: 'Appen har testats ingående i kliniska prövningar och är godkänd för användning i ett antal länder och regioner, däribland Australien, Kanada, Europeiska unionen, Nya Zeeland, Norge, Schweiz, Storbritannien och USA.',
    isAvailable: 'Är CamAPS FX tillgänglig där jag bor?',
    isAvailableAnswer1: 'CamAPS FX är tillgänglig på utvalda diabetesmottagningar och för personer som finansierar den själva och genomgår en webbaserad utbildning. Fråga på din mottagning eller gå till',
    isAvailableAnswer2: 'Beställningar',
    isAvailableAnswer3: 'om du vill beställa appen.',
    whatIsLiberty: 'Vad är CamAPS Liberty?',
    whatIsLibertyAnswer: 'CamAPS Liberty är en funktion i CamAPS FX. När den är aktiverad behöver användare inte räkna kolhydrater eller ge bolus före måltider och mellanmål.',
    whatIsLibertyMoreInfo1: 'Mer information finns på vår ',
    whatIsLibertyPageLink: 'CamAPS Liberty-sida',
    whatIsLibertyMoreInfo2: ', eller ladda ner detta ',
    whatIsLibertyFactsheetLink: 'faktablad',
    whatIsLibertyMoreInfo3: '.',
    whatIsLibertyFactsheetUrl: '#',
    cost: 'Hur mycket kostar CamAPS FX?',
    costAnswer1: 'Du hittar information om priser under',
    costAnswer2: 'på webbplatsen.',
    compatibleCgm: 'Vilka CGM-enheter är kompatibla med CamAPS FX?',
    compatibleCgmBody: 'CamAPS FX är kompatibelt med Dexcom G6, Dexcom G7, FreeStyle Libre 3 och FreeStyle Libre 3 Plus. Klicka på länkarna för att se vilka smartphones och operativsystem som är kompatibla.',
    whatPumps: 'Vilka insulinpumpar är kompatibla med CamAPS FX?',
    whatPumpsAnswer1: 'CamAPS FX är kompatibel med YpsoPump-insulinpumpar på Google Play och Apple App Store.',
    whatPumpsAnswer2: '',
    whatPumpsAnswer3: '',
    whatPumpsAnswerHtml: 'https://advancedtherapeutics.org.uk/shop/dana-diabecare-insulin-pump/dana-rs-insulin-pump-2018',
    whatPhone: 'Vilka smartphones är kompatibla med CamAPS FX?',
    whatPhoneAnswer: 'Din smartphone måste vara kompatibel med den CGM-enhet du använder.',
    cgmManufacturerListText: 'Kontrollera kompatibilitetslistan från tillverkaren av din CGM-enhet för Dexcom G6, Dexcom G7, FreeStyle Libre 3 eller FreeStyle Libre 3 Plus.',
    whatOperating: 'Vilka operativsystem är kompatibla med CamAPS FX?',
    whatOperatingAnswer: 'CamAPS FX stöder Android 13 till 16 och iOS 18 till 27, inklusive efterföljande mindre uppdateringar. Ditt operativsystem måste dessutom vara kompatibelt med den CGM-enhet du använder.',
    whatOperatingManufacturerText: 'Kontrollera kompatibilitetslistan från tillverkaren av din CGM-enhet för Dexcom G6, Dexcom G7, FreeStyle Libre 3 eller FreeStyle Libre 3 Plus.',
    whatPhoneAnswerDexcomHtml:'https://www.dexcom.com/en-GB/compatibility/g6',
    whatPhoneAnswerDexcomG7Html:'https://www.dexcom.com/en-GB/compatibility/g7',
    whatPhoneAnswerLibreHtml:'https://freestyleserver.com/Payloads/IFU/2026/q2/ART43193-006_rev-AP-pub.pdf',

    whereUpload: 'Var kan jag överföra mina data till och från CamAPS FX?',
    whereUploadAnswer: 'I nuläget kan data från CamAPS FX överföras till mylife Cloud och Glooko.',
    whatLanguage: 'Vilka språk är tillgängliga i CamAPS FX?',
    whatLanguageAnswer: 'CamAPS FX finns på engelska, tjeckiska, danska, nederländska, franska, finska, tyska, italienska, norska, polska, spanska och svenska.',
    whereResults: 'Var hittar jag resultaten av era kliniska prövningar?',
    whereResultsAnswer1: 'Publikationer som rör användningen av Cambridges kontrollalgoritm finns att hämta',
    whereResultsAnswer2: 'här.',
    whereResultsAnswer3: 'De viktigaste publikationerna har gjorts i',
    whereResultsAnswer4: 'och',

    wantMoreInfoIOS: 'Vill du veta mer om CamAPS FX-appen för iOS?',
    wantMoreInfoIOSanswer1: '',
    wantMoreInfoIOSanswer2: 'Klicka här',
    wantMoreInfoIOSanswer3: 'för att läsa mer.',
    wantMoreInfoIOSanswerHtml: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/faq.info/iOS+FAQ_SE_005.pdf',

    wantMoreInfoCGManswerHtml: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/faq.info/Sensor_FAQs_SE.pdf',
};
